module.exports = __webpack_public_path__ + "img/leftImg.20923902.png";